import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, youtubeCampaignSummaryFetched, youtubeAdgroupSummaryFetched, youtubeCreativeSummaryFetched } from './duck';
import { youtubeCampaignSummaryEndpoint, youtubeAdgroupSummaryEndpoint, youtubeCreativeSummaryEndpoint } from './selectors';

export function* fetchYouTubeCampaignSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(youtubeCampaignSummaryEndpoint, action.payload)
            }
        );

        yield put(youtubeCampaignSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchYouTubeAdgroupSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(youtubeAdgroupSummaryEndpoint, action.payload)
            }
        );

        yield put(youtubeAdgroupSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchYouTubeCreativeSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(youtubeCreativeSummaryEndpoint, action.payload)
            }
        );

        yield put(youtubeCreativeSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* youtubeSaga({ api }) {
    yield all([
        takeLatest(actions.FETCH_CAMPAIGN_SUMMARY, fetchYouTubeCampaignSummary, api),
        takeLatest(actions.FETCH_ADGROUP_SUMMARY, fetchYouTubeAdgroupSummary, api),
        takeLatest(actions.FETCH_CREATIVE_SUMMARY, fetchYouTubeCreativeSummary, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/youtube/saga.js